


export function cleanEquipmentData(request) {

    let list = []

    request.equipmentRequestItemsForEquipmentRequest.forEach(item => {

        let listItem = { id: item.id }

        // sku
        listItem['sku'] = item.equipment.sku

        // name
        listItem['name'] = item.equipment.name

        // description
        listItem['description'] = item.equipment.description

        // requestedQuantity
        listItem['requestedQty'] = item.requestedQuantity

        // sentQuantity
        listItem['sentQty'] = item.sentQuantity

        // note
        listItem['note'] = item.note

        list.push(listItem)
    })

    return list
}